const docListing = $('[data-doc-listing]');
const docListingCount = $('[data-doc-listing-count]');
const docListingSection = docListing.closest('section');
const errorDiv = $('[data-section="documentsListing"] .error-message');

$(document).ready(function() {

	var lot = getUrlParameter('lot');
	if (lot) {
		$('.search-form input').val(lot);
		getLotData(lot);
		// $('.search-form button[type="submit"]').trigger('click');
	}

    $('.search-form').on('submit', function(event) {
        event.preventDefault();
        var lot = $(this).find('input[name="lot"]').val().trim();
		getLotData(lot);
		
    });

    $('.search-form [type="button"]').on('click', function() {
        $('.search-form input').val('');
        $('.search-form input').focus();
		$('[data-section="listType2"]').show();
		docListingSection.hide();
		docListingCount.html('');
		docListing.html('');
    });
});


function getLotData(lot) {
	if (/^\d+$/.test(lot)) {
		errorDiv.html('')
		var url = '/documents.json?lot=' + encodeURIComponent(lot);
		$.ajax({
			url: url,
			method: 'GET',
			success: function(data) {

				console.log('Response data:', data.data.length);

				if (data.data.length == 0) {
					errorDiv.html('No lot found, please try again')
					$('[data-section="listType2"]').show();
					docListingSection.hide();
					docListingCount.html('');
					docListing.html('');
					return false;
				}

				var combinedHtml = '';
				
				$.each(data.data, function(index, item) {
					combinedHtml += item.html;
				});

			if (combinedHtml.length == 0) {
				errorDiv.html('No documents found, please try again')
				$('[data-section="listType2"]').show();
				docListingSection.hide();
				docListingCount.html('');
				docListing.html('');
				return false;
			}

			if (docListing.length) {
				// Collect all stages from the returned data
				var stages = [];
				$.each(data.data, function(index, item) {
					if (item.stage && stages.indexOf(item.stage) === -1) {
						stages.push(item.stage);
					}
				});

				// Hide/show sections based on whether their data-stages contains any of the stages
				$('[data-section="listType2"][data-stages]').each(function() {
					var sectionStages = $(this).attr('data-stages').split(',');
					var hasMatchingStage = false;
					
					for (var i = 0; i < stages.length; i++) {
						if (sectionStages.indexOf(stages[i]) !== -1) {
							hasMatchingStage = true;
							break;
						}
					}
					
					if (hasMatchingStage) {
						$(this).show();
					} else {
						$(this).hide();
					}
				});

				// Hide sections without data-stages attribute
				$('[data-section="listType2"]:not([data-stages])').hide();

				docListingSection.show();
				docListingCount.html('<p>Lot <strong>' + lot + '</strong> documentation</p>');
				docListing.html(combinedHtml);
			}
				
			},
			error: function(jqXHR, textStatus, errorThrown) {
				console.error('Request failed:', textStatus, errorThrown);
			}
		});
	} else {
		errorDiv.html('Please enter only numbers')
	}
}